module.exports = __webpack_public_path__ + "img/SL-M-240-280.76195d64.svg";